import React, { useState } from "react";

import { useContext } from "react";
import { HomeContext, FilterContext } from "../../Context";
import { getDisableFlag } from "../../Common/Functions";
import { Button } from "antd";
import cloneDeep from "lodash/cloneDeep";

function PushToVaidationApp() {
	let [pushToAppLoading, setPushToAppLoading] = useState(false);

	const { pushCensusShops, selectedPolygons } = useContext(HomeContext);
	const { state } = useContext(FilterContext);

	return (
		<>
			<Button
				className="blueclr "
				loading={pushToAppLoading}
				disabled={pushToAppLoading || getDisableFlag(selectedPolygons)}
				onClick={async () => {
					setPushToAppLoading(true);
					await pushCensusShops(cloneDeep(state));
					setPushToAppLoading(false);
				}}
			>
				Push To Validation App
			</Button>
		</>
	);
}

export default React.memo(PushToVaidationApp);
